import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetCulturesSuspense } from "api/generated/constants/constants";

export function useCulturesQuery() {
    return useGetCulturesSuspense({
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
